import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const TeamPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/#team', { replace: true });
  }, [navigate]);

  return null;
};

export default TeamPage;
